export default __webpack_public_path__ + "static/media/wwf_main_small.021ca405.jpg";